import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

/** 
* @author Opeoluwa
* @dateCreated 4th Aug 2023
 * @description This interceptor adds the authentication token to the request headers for authenticated users.
 * It intercepts all outgoing HTTP requests and modifies them to include the token.
 * @modifiedBy - None
 * @dateModified - None
 * @reasonForModification - None
 */
@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

    /** 
       * @author Opeoluwa
   * @dateCreated 4th Aug 2023
   * @description The function intercepts outgoing HTTP requests and adds the authentication token to the headers.
   * If the user is not authenticated, it does not add the token.
   * @param request - The outgoing HttpRequest.
   * @param next - The HttpHandler for the next interceptor in the chain.
   * @returns An Observable of the HttpEvent, including the modified request with the token if applicable.
   * @modifiedBy - None
   * @dateModified  - None
   * @reasonForModification  - None
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the authentication token from the AuthService
    const authToken = this.authService.getAuthToken();
    if (authToken) {
      // Clone the request and add the authorization token to the headers
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    // Continue with the modified request
    return next.handle(request);
  }
}
